import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map, filter, find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { unicodeToString } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import AudioButton from "../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import PauseIcon from "@mui/icons-material/Pause";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";
import RecordButton from "../../../Components/Media/RecordButton";
import SmartCheckCard from "../../../Components/Card/AssetUI/SmartCheckCard";
import { checkRECADVParams } from "../../../Js/Common";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const RECADV = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [isPlaying, setIsPlaying] = useState(false);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  let [localAudios, setLocalAudios] = useState([]);
  let [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  let [smartCheckResult, setSmartCheckResult] = useState([]);
  let [smartCheckAdvResult, setSmartCheckAdvResult] = useState([]);
  let [unscripted, setUnscripted] = useState(false);
  let [currentRecord, setCurrentRecord] = useState(false);
  let [aiEnable, setAiEnable] = useState(true);
  let [whatToCheck, setWhatToCheck] = useState([]);

  // Redux state
  const {
    showAnswer,
    assetLogObj,
    attempted,
    currentAttempt,
    numberOfAttemptes,
    recordingContinueIndex,
    recordingAudioContinueIndex,
    attempedAnsLog,
    fromCompletedTab,
    optionWiseAns,
  } = useSelector((state) => state.currentAsset);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      setLocalAudios(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      setCurrentIndexPlay(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      dispatch(currentAssetSliceActions.setCurrentAttemptData([]));
      if (
        siteConfig?.customer?.addOnInfo?.isExpertSystem == undefined ||
        siteConfig?.customer?.addOnInfo?.isExpertSystem
      ) {
        if (
          props.content.epage.options?.ai_enable != undefined &&
          !fromCompletedTab
        ) {
          setAiEnable(props.content.epage.options.ai_enable);
          dispatch(
            currentAssetSliceActions.setAiEnable(
              props.content.epage.options.ai_enable
            )
          );
        }
      } else {
        setAiEnable(false);
        dispatch(currentAssetSliceActions.setAiEnable(false));
      }
      //console.log("#$#$#$",);
      let actualAnswers = [];
      let wc = [];
      for (let y = 0; y < props.content.epage.options.content.length; y++) {
        let childNodes = [];
        let ans = [];
        let innerwc = [];
        let index = 0;
        if (document.getElementById(`${y}_ansTextId`)) {
          childNodes = document
            .getElementById(`${y}_ansTextId`)
            .getElementsByTagName("span")[0].parentNode.childNodes;
          for (let x = 0; x < childNodes.length; x++) {
            if (childNodes[x]["textContent"].trim().length > 0) {
              let splitArr = childNodes[x]["textContent"]
                .trim()
                //.match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g);
                .split(" ");
              splitArr.map((val, ind) => {
                if (
                  childNodes[x]["nodeName"] &&
                  childNodes[x]["nodeName"].toUpperCase() == "SPAN"
                ) {
                  document.getElementById(
                    `${y}_${index}_actualSpan`
                  ).style.fontWeight = "bold";
                  document.getElementById(
                    `${y}_${index}_actualSpan`
                  ).style.borderBottom = "solid";
                  document.getElementById(
                    `${y}_${index}_actualSpan`
                  ).style.borderBottomColor = "#3A54AF";
                  let foundObj = find(
                    props.content.epage.options.content[y][
                      "record_check_params"
                    ],
                    { btn_id: childNodes[x]["id"] }
                  );
                  innerwc.push({
                    index: index,
                    check_params: foundObj["check_params"],
                    word: childNodes[x]["innerText"],
                  });
                  ans.push({ index: index, status: true });
                } else {
                  ans.push({ index: index, status: false });
                }
                index++;
              });
            }
          }
          wc.push(innerwc);
        }
        console.log("wc", wc);
        setWhatToCheck(wc);
        actualAnswers.push(map(filter(ans, { status: true }), "index"));
      }

      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );

      if (props.content.epage.options.unscripted_text) {
        setUnscripted(true);
      } else {
        setUnscripted(false);
      }
      setSmartCheckResult([]);
      setSmartCheckAdvResult([]);

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content, siteConfig]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    if (fromCompletedTab) {
      setAiEnable(false);
      dispatch(currentAssetSliceActions.setAiEnable(false));
    }
  }, [fromCompletedTab]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    setLocalAudios(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(null)
      )
    );
    setCurrentOptionIndex(0);
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
      setLocalAudios([]);
      setSmartCheckResult([]);
      setSmartCheckAdvResult([]);
      setUnscripted(false);
    };
  }, []);

  const getTextToCheck = (fulltext) => {
    return unicodeToString(fulltext)
      .replace(/<\/?div[^>]*>/g, "")
      .replace(/<\/?p[^>]*>/g, "")
      .replace(/<\/?span[^>]*>/g, "")
      .replace(/<\/?br[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\n/g, " ");
    //.match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g)
  };

  const updateUserAnswer = (index, innerIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = newArray[index].map((item, i) => {
        return item;
      });
      let pos = innerArray.indexOf(innerIndex);
      if (pos == -1) {
        innerArray.push(innerIndex);
      } else {
        innerArray.splice(pos, 1);
      }
      newArray[index] = [...innerArray];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const setAudioLinks = (audioLink, index) => {
    let newArray = [...localAudios];
    newArray[index] = audioLink;
    setLocalAudios(newArray);
    if (userInfo.rolesInfo.title.toLowerCase() != "learner") {
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setSmartCheck = (result, filename, index) => {
    console.log("SFGGF", result, filename, index);
    if (result != "site_server") {
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
      console.log("filename", filename);
      let newArray = [...smartCheckResult];
      let updateFlag = true;
      if (
        newArray[index] &&
        !unscripted &&
        +newArray[index]["utterance"][0]["nativeness_score"] >
          result["utterance"][0]["nativeness_score"]
      ) {
        updateFlag = false;
      }

      newArray[index] = result;
      if (updateFlag && aiEnable) {
        dispatch(currentAssetSliceActions.setSmartCheckData(newArray));
      }
      console.log("newArray", newArray);
      setSmartCheckResult(newArray);
    } else {
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
    }
  };

  const setSmartAdvCheckFun = (result, whattocheck, index) => {
    if (
      result != "site_server" &&
      userInfo.rolesInfo.title.toLowerCase() == "learner"
    ) {
      let tempArr = checkRECADVParams(whattocheck, result);
      let newArray = [...smartCheckAdvResult];
      newArray[index] = tempArr;
      if (aiEnable) {
        dispatch(currentAssetSliceActions.setSmartCheckAdvData(newArray));
      }
      setSmartCheckAdvResult(newArray);
    }
  };

  const setFiles = (filename, index) => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      let newArray = [...userAnswer];
      newArray[index] = filename;
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div className={classes.scrollBar}>
      {props.content &&
        props.content.epage.options.content &&
        props.content.epage.options.content.map((val, index) => {
          return (
            <Box>
              <Grid sx={{ mt: 0, p: 1 }}>
                {val && val.media && (
                  <OptionMedia
                    media={val.media}
                    isPlaying={currentIndexPlay[index]}
                    setPlayMode={(status, end) => {
                      setPlayMode(status, index, end);
                    }}
                    disabled={
                      recordingContinueIndex != -1 ||
                      recordingAudioContinueIndex != -1
                    }
                  ></OptionMedia>
                )}
              </Grid>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  border: 1,
                  borderColor: "#D9D9D9",
                  color: "primary.main",
                  borderRadius: 10,
                  boxShadow: 0,
                  //cursor: "pointer",
                  py: 2,
                  pl: 2,
                  "@media (min-width: 1636px)": {
                    mt: 15,
                  },
                }}
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    ml: 1,
                    //cursor: "pointer"
                  }}
                >
                  {optionWiseAns && optionWiseAns.length > 0 && (
                    <StatusIndicator
                      correct={optionWiseAns[index]}
                    ></StatusIndicator>
                  )}
                  <Grid container>
                    <Grid xs={9} alignContent={"center"}>
                      <div
                        className="font_1_6"
                        style={{
                          fontWeight: "500",
                          fontSize: "1rem",
                          display: "inline-block",
                        }}
                      >
                        {unicodeToString(val["text"])
                          .replace(/<\/?div[^>]*>/g, "")
                          .replace(/<\/?p[^>]*>/g, "")
                          .replace(/<\/?span[^>]*>/g, "")
                          .replace(/<\/?br[^>]*>/g, "")
                          .replace(/&nbsp;/g, " ")
                          .replace(/\n/g, " ")
                          //.match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g)
                          .split(" ")
                          .map((valInner, ind) => {
                            return (
                              <span
                                id={`${index}_${ind}_actualSpan`}
                                style={{
                                  display: "inline-block",
                                  lineHeight: "1.6",
                                  margin: "0px 3px",
                                  borderBottomStyle: "none",
                                  borderBottomColor: "#FFFFFF",
                                  fontWeight: "500",
                                }}
                              >
                                {valInner}
                              </span>
                            );
                          })}
                      </div>
                      <div
                        style={{ display: "none" }}
                        dangerouslySetInnerHTML={{
                          __html: unicodeToString(val["text"]),
                        }}
                        id={`${index}_ansTextId`}
                      ></div>
                    </Grid>
                    <Grid xs={3} textAlign={"right"}>
                      <RecordButton
                        textToCheck={val.text ? getTextToCheck(val.text) : ""}
                        alreadyRecorded={
                          localAudios.length > 0 && localAudios[index]
                            ? localAudios[index]
                            : null
                        }
                        recordedAudio={(audio) => {
                          setAudioLinks(audio, index);
                        }}
                        smartCheck={(data, filename) => {
                          setSmartCheck(data, filename, index);
                          setSmartAdvCheckFun(data, whatToCheck[index], index);
                        }}
                        uploadedAudioName={(filename) => {
                          setFiles(filename, index);
                        }}
                        checkOnPause={aiEnable}
                        resetComponent={true}
                        numberOfAttemptes={
                          siteConfig.customer?.addOnInfo?.isSelfLearning &&
                          unscripted
                            ? 1
                            : numberOfAttemptes
                        }
                        unscripted={unscripted}
                        index={index}
                        disabled={
                          (recordingContinueIndex != -1 &&
                            recordingContinueIndex != index) ||
                          recordingAudioContinueIndex != -1 ||
                          attempedAnsLog ||
                          (userInfo.rolesInfo.title.toLowerCase() ==
                            "learner" &&
                            attempted)
                        }
                        audioDisable={
                          (recordingAudioContinueIndex != -1 &&
                            recordingAudioContinueIndex != index) ||
                          recordingContinueIndex != -1
                        }
                        disabledAll={currentIndexPlay.indexOf(true) > -1}
                        disablePercentageLimitOff={true}
                      ></RecordButton>
                    </Grid>
                  </Grid>
                </Grid>

                {smartCheckResult &&
                  smartCheckResult.length > 0 &&
                  smartCheckResult[index] &&
                  aiEnable && (
                    <Grid item xs={12} sx={{ mx: 2, my: 1 }}>
                      <Box sx={{ pa: 0, width: "100%" }}>
                        <Box>
                          <SmartCheckCard
                            whatToCheck={whatToCheck[index]}
                            advanced={true}
                            smartCheckResult={smartCheckResult[index]}
                            unscripted={unscripted}
                          ></SmartCheckCard>
                        </Box>
                      </Box>
                    </Grid>
                  )}
              </Grid>
            </Box>
          );
        })}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#adbdff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3751A8",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#adbdff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3751A8",
      borderRadius: 5,
    },
  },
});
export default RECADV;
